import SwatchPicker from "../SwatchPicker";
import "./ColorMapper.css";

interface Props {
    colorMap: string[];
    stretch?: boolean;
    hideHeader?: boolean;
    onChange?: (map: string[]) => void;
}

export default function ColorMapper({
    colorMap,
    stretch,
    hideHeader,
    onChange,
}: Props) {
    return (
        <div className="color-mapper">
            {!hideHeader && (
                <h2
                    style={{
                        margin: "0",
                        padding: "0",
                        background: "var(--accent-a)",
                        fontSize: "1rem",
                    }}
                >
                    Color Options
                </h2>
            )}
            <div className="colors">
                {colorMap &&
                    colorMap.map((cMap, idx) => {
                        return (
                            <SwatchPicker
                                color={cMap}
                                onChange={(color) => {
                                    if (!onChange) return;
                                    const newMap = [...colorMap];
                                    newMap[idx] = color;
                                    onChange(newMap);
                                }}
                                key={idx}
                            />
                        );
                    })}
                {(!colorMap || colorMap.length === 0) && (
                    <SwatchPicker color="#00000000" disabled={true} />
                )}
            </div>
        </div>
    );
}
